
export const init = (survey: any) => {
  const sequentialnumbering = {
    name: 'sequentialnumbering',
    title: 'Sequential Numbering',
    iconName: '',
    widgetIsLoaded: () => true,

    isFit: (question) => question.getType() === 'sequentialnumbering',

    activatedByChanged: (activatedBy) => {
      survey.JsonObject.metaData.addClass('sequentialnumbering', [], null, 'text');
      survey.JsonObject.metaData.addProperties('sequentialnumbering', [
        { name: 'zeroPadding:number', default: 1 },
      ]);
    },

    isDefaultRender: false,
    htmlTemplate: '<div><input type="text" id="sequentialnumbering" name="sequentialnumbering" class="sv-text" disabled></div>',
    afterRender: (question, el) => {
      const text = el.getElementsByTagName('input')[0];
      if (question.value && question.value.calculated) {
        text.value = question.value.calculated;
      } else {
        text.value = '';
      }
    },
  };

  survey.CustomWidgetCollection.Instance.addCustomWidget(sequentialnumbering, 'customtype');
};

